export default __webpack_public_path__ + "static/media/O-082.e85352eb.png";